import { createTheme, responsiveFontSizes } from "@mui/material/styles";

export default responsiveFontSizes(
  createTheme({
    typography: {
      fontFamily: [
        "Outfit",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      h1: {
        fontWeight: 400,
        lineHeight: 1,
      },
      h2: {
        fontWeight: 400,
        lineHeight: 1,
      },
      h3: { fontWeight: 400, lineHeight: 1 },
      h4: { fontWeight: 400, lineHeight: 1 },
      h5: { fontWeight: 400, lineHeight: 1 },
      h6: {
        fontWeight: 400,
        lineHeight: 1,
      },
      caption: {
        lineHeight: 1,
      },
      body1: {
        lineHeight: 1,
      },
    },
    palette: {
      primary: {
        main: "#F45C1C",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#2D3AAC",
        contrastText: "#FFFFFF",
      },
      text: {
        primary: "#19191A",
        secondary: "#4B4B4E",
      },
      success: {
        main: "#4CCC6B",
      },
      warning: {
        main: "#F45C1C",
      },
      error: {
        main: "#D83232",
      },
      info: {
        main: "#2D3AAC",
      },
    },
    components: {
      MuiAlert: {
        styleOverrides: {
          root: {
            fontWeight: 700,
            padding: "0 16px",
            borderRadius: "5px 0 0 5px",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: "#898989",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            border: 0,
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          icon: {
            color: "#2D3AAC",
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            color: "#898989",
            borderRadius: 5,
          },
          notchedOutline: { borderColor: "#EBEBF2" },
        },
      },
      MuiButtonBase: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            textTransform: "none",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            textTransform: "none",
            fontWeight: 700,
          },
        },
        defaultProps: {
          disableElevation: true,
          variant: "contained",
          color: "primary",
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            border: "1px solid #E3E3E6",
            borderLeft: 0,
            borderRight: 0,
            boxShadow: "none",
            "&:not(:last-child)": {
              borderBottom: 0,
            },
            "&:before": {
              display: "none",
            },
          },
        },
        defaultProps: {
          square: true,
          elevation: 0,
          variant: "outlined",
          disableGutters: true,
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: {
            backgroundColor: "#E8E8EA",
            borderRadius: 0,
          },
          content: {
            alignItems: "center",
          },
        },
      },
      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            borderTop: "1px solid #E3E3E6",
          },
        },
      },
      MuiDialog: {
        defaultProps: { PaperProps: { elevation: 0 } },
      },
      MuiPaper: {
        defaultProps: {
          elevation: 0,
        },
        styleOverrides: {
          rounded: {
            borderRadius: "12px",
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: "none",
          },
        },
      },
      MuiList: {
        defaultProps: { disablePadding: true },
      },
      MuiMenu: {
        defaultProps: {
          elevation: 0,
        },
        styleOverrides: {
          paper: { border: "1px solid #D7D7D9", borderRadius: "5px" },
          list: {
            "& li:nth-last-of-type(1)": {
              border: 0,
            },
          },
        },
      },
      MuiMenuItem: {
        defaultProps: { dense: true },
        styleOverrides: {
          root: {
            borderRadius: 0,
            borderBottom: "1px solid",
            borderColor: "#D7D7D9",
            color: "#2D3AAC",
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            borderRadius: "8px",
            backgroundColor: "#19191A",
          },
          arrow: {
            color: "#19191A",
          },
        },
      },
    },
  })
);
